import { forEach } from 'lodash';
import api from '@/api';

class Team {
  /**
   * @returns {AxiosPromise<any>}
   */
  static users(teamId, params = {}) {
    return api.get(`/teams/${teamId}/users`, { params });
  }

  /**
   * Return a team hierarchy as flat, but with string concat names based on their hierarchy
   * @param teams
   * @returns {Array}
   */
  static formatTeams(teams = {}) {

    const formattedTeams = [];
    const format = (object, parentLabel = '') => {
      forEach(object, (obj) => {
        const { children, depth } = obj;
        let label = obj.value;

        if (depth > 0) {
          label = `${parentLabel} > ${obj.value}`;
        }

        if (children) {
          obj.children = format(children, label);
        }

        if (obj.children.length === 0) {
          delete obj.children;
        }

        obj.team = label;
        obj.value = label;
        obj.name = obj.value;

        formattedTeams.push(obj);
      });

      return formattedTeams;
    };

    const allTeams = format(teams);

    allTeams.forEach((team) => {
      delete team.children;
    });

    return allTeams;
  }
}

export default Team;
